import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
  pure: true
})
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!items.length) return items;
    if (!searchText) return items;

    const term = searchText.toLowerCase();

    return items.filter(item => {
      return Object.values(item).some(val => {
        // Safely convert value to string and check
        return String(val).toLowerCase().includes(term);
      });
    });
  }
}
